export enum Permission {
  StorefrontOnboarding = 'storefront_onboarding.modify',
  StorefrontOnboardingAdminStorefrontSetupView = 'storefront_onboarding_admin_storefront_setup.view',
  StorefrontOnboardingAdminStorefrontSetupModify = 'storefront_onboarding_admin_storefront_setup.modify',
}
